// Height of the phone's bottom navigation bar, which floating buttons sit above.
export const BOTTOM_BAR = 56
